import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IExtendCalendarConfig } from '../../interfaces/extendCalendarConfig';
declare var $: any;

@Component({
  selector: 'app-edit-form',
  templateUrl: './edit-form.component.html'
})
export class EditFormComponent implements OnChanges {
  @Input() config: any[] = []; // Configuración del formulario
  @Input() customValidator: any;
  @Input() data: any = {}; // Datos iniciales para editar

  @Output() form = new EventEmitter<FormGroup>();

  customForm: FormGroup;
  calendarConfig: IExtendCalendarConfig = { value: null, valid: true };

  constructor(private fb: FormBuilder) { }

  ngOnChanges(): void {
    this.createForm();
  }

  private createForm(): void {
    const group: any = {};
    this.config.forEach(control => {
      const validators = [];
      if (control.required && control.type !== 'boolean') {
        validators.push(Validators.required);
      }
      if (control.max !== undefined && control.type === 'number') {
        validators.push(Validators.max(control.max));
      }
      if (control.min !== undefined && control.type === 'number') {
        validators.push(Validators.min(control.min));
      }
      if (control.hasOwnProperty('type') && control.type === 'calendar') {
        this.calendarConfig = control.calendarConfig;
      }
      group[control.name] = [this.data[control.name] ?? '', validators];
    });

    /* this.form = this.fb.group(group);*/
    if (this.customValidator) {
      // Agregar un validador al formulario completo
      this.customForm = this.fb.group(group, {
        validators: this.customValidator // Validador personalizado
      });
    } else {
      this.customForm = this.fb.group(group);
    }

    // Emitimos el formulario para que el padre lo reciba
    this.form.emit(this.customForm);
  }
}
